export default __webpack_public_path__ + "static/media/cones_two_kids.08e5c0e4.jpg";